import Routine, { RUN } from "+/Engine/Routine";
import DataTypes from "+/Engine/Helpers/DataTypes";

export default class DeleteEntity extends Routine {
  assertValidParams(params) {
    DataTypes.assertObjectKeyExistsOfType("entityType", params, DataTypes.assertString);
    DataTypes.assertObjectKeyExistsOfType("entityPk", params, DataTypes.assertObject);
  }

  [RUN](params) {
    const { entityType } = params;
    const pkFields = this.app.getEntityPrimaryKeyFields(entityType);
    const entityPk = {};
    pkFields.forEach(field => {
      entityPk[field] = params.entityPk[field];
    });
    this.app.deleteEntity(entityType, entityPk);
    return { entityType, entityPk };
  }
}
Routine.register("DeleteEntity", DeleteEntity);
